import { render, staticRenderFns } from "./ProductChannelAssociationModalCmp.vue?vue&type=template&id=4b716ec4&scoped=true&"
import script from "./ProductChannelAssociationModalCmp.vue?vue&type=script&lang=js&"
export * from "./ProductChannelAssociationModalCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductChannelAssociationModalCmp.vue?vue&type=style&index=0&id=4b716ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b716ec4",
  null
  
)

export default component.exports